import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_footerMusic = _resolveComponent("footerMusic");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _ctx.$store.state.isFooterShow ? (_openBlock(), _createBlock(_component_footerMusic, {
    key: 0
  })) : _createCommentVNode("", true)], 64);
}